import { IAppState } from '../state/IAppState';

export const initialState: IAppState = {
  identifier: 'bird-portal'
}

export function appStateReducer(state = initialState, action: any): IAppState {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/appState.reducer.ts